import { create } from 'zustand'

type DrawerStore = {
  isDrawerOpen: boolean
}

type DrawerAction = {
  handleDrawerClose: () => void
  setDrawerToggle: () => void
}

const initialValue: DrawerStore = {
  isDrawerOpen: false,
}

export const useDrawerStore = create<DrawerStore & DrawerAction>((set) => ({
  ...initialValue,
  handleDrawerClose() {
    set(() => ({
      isDrawerOpen: false,
    }))
  },
  setDrawerToggle() {
    set(({ isDrawerOpen }) => ({
      isDrawerOpen: !isDrawerOpen,
    }))
  },
}))
